import { personName, relationLabel } from './profileFormat'

function NetworkList({ users, status, truncated, selectedId, onSelect, empty }) {
  if (status === 'loading') return <div className="net-status">Loading…</div>
  if (status === 'error') return <div className="net-status">Could not load people.</div>
  if (!users.length) {
    return <div className="net-status">{empty || 'No people to show.'}</div>
  }

  return (
    <div className="net-list">
      {users.map((person) => {
        const label = relationLabel(person.relation)
        const selected = String(person._id) === String(selectedId)
        return (
          <button
            key={person._id}
            type="button"
            className={'net-row' + (selected ? ' is-selected' : '')}
            onClick={() => onSelect(person)}
          >
            <span className="net-row-name">{personName(person)}</span>
            <span className="net-row-meta">
              {[person.occupation, label].filter(Boolean).join(' · ')}
            </span>
          </button>
        )
      })}
      {truncated ? <div className="net-status">Showing 100 — keep typing to narrow.</div> : null}
    </div>
  )
}

export default NetworkList
